import React, { useEffect, useState } from "react";
import DataTable from "../../components/dataTable";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { getUserCredential, getTenantCookieData, getLocalStorage } from "../../lib/cookies";
import { GET_LOGIN_LOG_DATA, GET_DB_ROLE_TYPE_KEY_LIST } from "../../api-setup/api-endpoints";
import MultiSelectDropdown from "src/components/multiSelect";
import {
  camelize,
  formatDateOnly,
  formatDateOnlyMoment,
  formatSystemDateTime,
  getfilterDataString,
  replaceBlankAndMerge,
  toCamelCase,
} from "../../utils/utils";
import { columnMenuProps } from "../../components/customColumnMenu";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { HeaderPage } from "../base/headerPage";
import { Label, Error } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { LoadingPanel } from "../../components/loadingPanel";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { processTreeData } from "../../utils/treeDropdowndata";
import MessageSchema from "../../utils/messageSchema";
import { ToggleButton } from "@progress/kendo-react-dateinputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import useAPI from "./service";

import CustomDropdown from "src/components/customDropdown";
import { transformDateTime } from "src/lib/date-time.util";
import useColumnReorder from "src/custom-hooks/useColumnReorder";
import { generateHeader, GETAPI } from "src/api-setup/api-helper";
import { setNewMessage } from "src/redux/actions/setting-actions";
import moment from "moment";

const selectField = "selected";
const expandField = "expanded";
const dataItemKey = "id";
const subItemsField = "items";

const fields = {
  selectField,
  expandField,
  dataItemKey,
  subItemsField,
};

const login_log_status = [
  { text: "Select All", id: null },
  { text: "Success", id: "success", key: 1 },
  { text: "Failed", id: "fail", key: 2 },
];
export const CustomToggleButton = (props) => {
  return (
    <Tooltip
      position="bottom"
      anchorElement="target"
      style={{
        paddingTop: 10,
      }}
    >
      <ToggleButton {...props} title="Calendar">
        <span className="k-icon k-font-icon k-i-calendar" title="Calendar" />
      </ToggleButton>
    </Tooltip>
  );
};

const LoginLogs = (pageProps) => {
  const DEFAULT_SORT = { number: 1, order: "DESC" };
  const divRef = React.createRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultPageSize = getTenantCookieData("record_per_page");

  const cookiesData = getUserCredential();
  const processEnv = process.env;
  const localStorageData = getLocalStorage(processEnv.REACT_APP_CREDENTIAL_KEY);
  const [columnsData, setColumnsData] = React.useState([]);
  const [isCheckColumn, setColumnCheck] = React.useState(false);
  const [exportDataClick, setExportDataClick] = React.useState(false);
  const [exportData, setExportData] = React.useState([]);

  const [filterData, setFilterData] = React.useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    sort_order: DEFAULT_SORT.order,
  });
  //state to set and get limit, offset
  const [pageData, setPage] = React.useState({
    skip: 0,
    take: defaultPageSize.recordTake,
  });
  const [filter, setFilter] = React.useState({
    value: "",
    operator: "contains",
  });

  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const [dbObjTypeFields, setDataObjFields] = React.useState({
    dbObjTypeValue: {
      id: "",
      text: "",
    },
    dbObjTypeData: [],
    isDBObjDataLoading: true,
    dbTypeListLoading: true,
    screenName: "",
  });
  const [loginLogStatusField, setLoginLogStatusField] = React.useState({
    loginLogStatusValue: {
      id: null,
      text: "Select All",
    },
    emailStatusData: [],
    isEmailStatusDataLoading: false,
    emailStatusListLoading: true,
    screenName: "",
  });
  const [errorObj, setErrorObj] = React.useState({
    start_date: "",
    end_date: "",
    db_obj_type: "",
    commonDateValidate: "",
  });
  // const [dbObjList, setDBObjList] = React.useState([]);
  const [selectedRoleType, setSelectedRoleType] = React.useState("");
  const [gridColumns, setGridColumns] = React.useState([]);

  const [dateFields, setDateFields] = React.useState({
    start_date: "",
    end_date: new Date(),
  });
  const [expanded, setExpanded] = React.useState([]);
  const DATA_TABLE_ID = "login-log-grid";

  const [list, Action] = useAPI();
  const [roleAccessDataFields, setRoleAccessDataFields] = React.useState({
    dropdownData: [],
    isDataLoading: true,
    isDataRefresh: false,
    isDataChanged: false,
    valuesData: [{ text: "Select All", id: 0 }],
  });
  const [originRoleAccessData, setOriginRoleAccessData] = React.useState([]);

  const defaultSelectedOption = {
    text: "Select All",
    id: 0,
  };

  const userRole = cookiesData.out_impersonate
    ? cookiesData.out_db_role_type_abbr
    : localStorageData.out_db_role_type_abbr;

  /*
    const [userRole, setUserRole] = useState();

    useEffect(()=>{
        setUserRole(cookiesData.out_impersonate ? cookiesData.out_db_role_type_abbr : localStorageData.out_db_role_type_abbr)
    },[])
    */
  const {
    columns,
    setColumns,
    data,
    setData,
    dataCount,
    initialLoading,
    noDataFound,
    isAPICalling,
    setAPICallingState,
    isSearchClick,
    setSearchClick,
  } = list;

  useEffect(() => {
    getRolesData();

    const formattedJanFirst = getFormattedJanFirst();
    setDateFields({
      ...dateFields,
      start_date: new Date(formattedJanFirst),
    });
  }, []);

  // const getFormattedJanFirst = () => {
  //     const now = new Date();
  //     const year = now.getFullYear();
  //     return `${year}-01-01`;
  //   };

  const getFormattedJanFirst = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() is 0-based
    return `${year}-${month}-01`;
  };

  React.useEffect(() => {
    if (columns.length === 0 && isSearchClick) {
      let apiData = getAPIData();
      apiData.in_filter = null;
      apiData.in_sort_number = DEFAULT_SORT.number;
      apiData.in_sort_order = "DESC";
      apiData.in_page_row_offset = 0;
      apiData.in_page_rows = defaultPageSize.recordTake;
      getEmailLogsAsync(apiData, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, isSearchClick]);

  React.useEffect(() => {
    if (columns.length > 0) {
      setColumnsData(columns);
      setGridColumns(columns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns]);

  React.useEffect(() => {
    if (isCheckColumn) {
      setGridColumns(columnsData);
      setColumnCheck(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckColumn]);

  const getPageTake = () => {
    return pageData.take;
  };

  const getPageSkip = () => {
    return pageData.skip;
  };

  const getAPIData = () => {
    let apiData = {};
    apiData.in_tenant_id = cookiesData.out_tenant_id;
    apiData.in_filter = null;
    apiData.in_sort_number = 2;
    apiData.in_sort_order = "DESC";
    apiData.in_page_row_offset = 0;
    apiData.in_page_rows = defaultPageSize.recordTake;
    return apiData;
  };

  const getEmailLogsAsync = async (reqBodyData, isSort) => {
    let obj = {};
    obj.reqBody = reqBodyData;
    obj.api = GET_LOGIN_LOG_DATA;
    let { api, reqBody } = obj;
    getDataListAPICall(reqBody, api);
  };

  const getDataListAPICall = async (reqBody, api) => {
    let startDate = formatDateOnlyMoment(dateFields.start_date, "YYYY-MM-DD");
    let endDate = formatDateOnlyMoment(dateFields.end_date, "YYYY-MM-DD");

    reqBody.in_user_key = cookiesData?.out_user_id;
    reqBody.in_db_role_key =
      userRole == "adm1"
        ? roleAccessDataFields?.valuesData?.map((role) => role.id).join(", ")
        : roleAccessDataFields?.dropdownData
            ?.filter((role) => role.key == cookiesData?.out_db_role_type_abbr)
            ?.map((val) => val.id)
            .join("");
    reqBody.in_login_log_status = loginLogStatusField?.loginLogStatusValue?.id;
    reqBody.in_start_date = startDate;
    reqBody.in_end_date = endDate;

    let res = await Action.getListDataAsync(GET_LOGIN_LOG_DATA, reqBody, dispatch);
    if (res) {
      setAPICallingState(false);
      setSearchClick(false);
    }
  };

  const useCol = (columns) => {
    return columns.map((column, idx) => {
      return column.show && column.title !== "" ? (
        <Column
          {...columnMenuProps(column)}
          key={idx}
          cell={StringReandOnlyCell}
          width={column.minWidth}
          sortable={true}
          format={column.format}
          resizable={true}
        />
      ) : (
        false
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const StringReandOnlyCell = React.useCallback((props) => {
    const { ariaColumnIndex, columnIndex, dataItem, field } = props;

    let val = dataItem[field || ""];

    if (field.indexOf("_mstr_key") !== -1) {
      val = dataItem[field.replace("_mstr_key", "_name") || ""];
    }
    let value = props.field === "custom_table_type" ? (val === "S" ? "Standard" : "Hierarchical") : val;
    const defaultRendering = (
      <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
        <span title={value}>{value}</span>
      </td>
    );

    return defaultRendering;
  }, []);

  let AuditColumn = useCol(gridColumns);

  const onClearFilter = () => {
    let apiData = getAPIData();
    //set in_params
    const dataVal = {
      ...apiData,
      in_filter: null,
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };

    //set filter to false
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
    });

    getEmailLogsAsync(dataVal, filterData.isSort);
  };

  const handleColumnMenu = async (columnMenuData, isFilter, isSort) => {
    let index = 1;
    let filterSkip = getPageSkip();
    let filterTake = getPageTake();

    if (isFilter) {
      filterSkip = 0;
      filterTake = pageSize.recordTake;

      //reset pager when filter applies
      setPage({ skip: filterSkip, take: filterTake });
    }

    if (data.length > 0 && columnMenuData[0] !== undefined) {
      let obj = Object.keys(data[0]);
      index = obj.findIndex((x) => x === columnMenuData[0].field) + 1;
    }

    let filterString = isFilter ? getfilterDataString(columnMenuData, gridColumns) : filterData.data;
    isFilter = false;
    filterString = replaceBlankAndMerge(filterString);

    if (filterString !== "") {
      isFilter = true;
    }

    let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
    let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

    isSort = !columnMenuData.length ? false : filterData.isSort;

    if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
      isSort = true;
      sortDir = columnMenuData[0].dir.toUpperCase();
      sortNumber = index;
    }
    const dataVal = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: isFilter ? filterString : null,
      in_sort_number: sortNumber,
      in_sort_order: sortDir,
      in_page_row_offset: filterSkip,
      in_page_rows: filterTake,
      in_user_key: cookiesData.out_user_id.toString(),
      in_user_role_filter: "> 0",
    };
    setFilterData({
      ...filterData,
      isFilter: isFilter,
      isSort: isSort,
      data: filterString,
      in_sort_number: sortNumber,
      sort_order: sortDir,
    });

    setAPICallingState(true);
    getEmailLogsAsync(dataVal, isSort);
  };

  const itemChange = (event) => {
    const field = event.field || "";
    const newData = data.map((item) =>
      item.user_key === event.dataItem.user_key ? { ...item, [field]: event.value } : item
    );
    setData(newData);
  };

  const getInFilter = () => {
    return filterData.isFilter ? filterData.data : null;
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const handlePageChange = async (event) => {
    const pageData = event.page;
    setAPICallingState(true);
    setPage({ skip: pageData.skip, take: pageData.take });
    let apiCallData = getAPIData();
    apiCallData.in_filter = getInFilter();
    apiCallData.in_sort_number = getInSortNumber();
    apiCallData.in_sort_order = getInSortOrder();
    apiCallData.in_page_rows = pageData.take;
    apiCallData.in_page_row_offset = pageData.skip;
    getEmailLogsAsync(apiCallData, filterData.isSort);
  };

  const onRefreshClick = async () => {
    setAPICallingState(true);
    let apiData = getAPIData();
    const dataVal = {
      ...apiData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: getPageTake(),
    };

    await getEmailLogsAsync(dataVal, filterData.isSort);
  };

  const handleMenuItemClick = (action) => {
    switch (action) {
      case "export":
        setExportDataClick(true);
        break;
      default:
        break;
    }
  };

  const headerConfig = {
    title: "Login Logs",
    id: "_log",
    action_menu: {
      export: { fx: handleMenuItemClick },
    },
    manage_col: {
      columnsData: columnsData,
      setColumnsData: setColumnsData,
      setColumnCheck: setColumnCheck,
    },
  };

  const onSearchButtonClick = () => {
    let isValid = handleValidation();
    if (isValid) {
      setPageSize(defaultPageSize);
      setPage({
        skip: 0,
        take: defaultPageSize.recordTake,
      });
      let selectedRoleTypeValue = dbObjTypeFields.dbObjTypeValue.text;
      setSelectedRoleType(selectedRoleTypeValue);
      setData([]);
      setColumns([]);
      setSearchClick(true);
      setFilterData({
        isSort: false,
        isFilter: false,
        data: "",
        in_sort_number: DEFAULT_SORT.number,
        sort_order: DEFAULT_SORT.order,
      });
    }
  };

  const parent = document.querySelector("#content-" + headerConfig.id);

  if (parent) {
    const exportToExcel = parent.querySelector(".export-to-excel");
    exportToExcel && exportToExcel.disableKendoMenu();
    data.length && exportToExcel && exportToExcel.enableKendoMenu();
  }

  const getExportData = async () => {
    setExportData([]);
    let apiData = getAPIData();
    const dataVal = {
      ...apiData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: getPageSkip(),
      in_page_rows: dataCount,
    };
    let startDate = formatDateOnlyMoment(dateFields.start_date);
    let endDate = formatDateOnlyMoment(dateFields.end_date);
    let response = "";
    let obj = {};
    obj.reqBody = dataVal;
    obj.api = GET_LOGIN_LOG_DATA;

    obj.reqBody.in_user_key = cookiesData?.out_user_id;
    // obj.reqBody.in_db_role_key = roleAccessDataFields.valuesData.map(role => role.id).join(", ");
    obj.reqBody.in_db_role_key =
      userRole == "adm1"
        ? roleAccessDataFields?.valuesData?.map((role) => role.id).join(", ")
        : roleAccessDataFields?.dropdownData
            ?.filter((role) => role.key == cookiesData?.out_db_role_type_abbr)
            ?.map((val) => val.id)
            .join("");
    obj.reqBody.in_login_log_status = loginLogStatusField?.loginLogStatusValue?.id;
    obj.reqBody.in_start_date = startDate;
    obj.reqBody.in_end_date = endDate;

    response = await Action.getExportDataAsync(GET_LOGIN_LOG_DATA, obj.reqBody, dispatch);

    if (response && response.length > 0) {
      response = response.map((val) => {
        val.last_attempt_login_date = val.last_attempt_login_date
          ? new Date(val.last_attempt_login_date)
          : val.last_attempt_login_date;
        val.last_success_login_date = val.last_success_login_date
          ? new Date(val.last_success_login_date)
          : val.last_success_login_date;
        return val;
      });
      setExportData(response);
    }
  };

  const handleValidation = () => {
    let isValid = true;
    let errObj = {};
    const { start_date, end_date } = dateFields;
    if (start_date && end_date) {
      const startDateObj = new Date(start_date);
      const endDateObj = new Date(end_date);

      if (start_date && end_date) {
        if (startDateObj > endDateObj) {
          errObj.commonDateValidate = MessageSchema.validDate;
        } else {
          errObj.commonDateValidate = "";
        }
      }
    } else {
      if (start_date === "" || start_date === null) {
        errObj.start_date = MessageSchema.actionStartDateRequired;
      }
      if (end_date === "" || end_date === null) {
        errObj.end_date = MessageSchema.actionEndDateRequired;
      }
    }

    if (dbObjTypeFields.dbObjTypeValue === "" || dbObjTypeFields.dbObjTypeValue === null) {
      errObj.db_obj_type = MessageSchema.screenNameRequired;
    } else {
      errObj.db_obj_type = "";
    }

    setErrorObj({ ...errObj });

    for (const [, value] of Object.entries(errObj)) {
      if (value !== "") {
        isValid = false;
      }
    }
    return isValid;
  };

  const onChangeLoginLogStatus = (e) => {
    setLoginLogStatusField({
      ...loginLogStatusField,
      loginLogStatusValue: e,
      screenName: e.text.replace(/\s/g, "").toLowerCase(),
    });
  };
  const onChange = (e) => {
    setDataObjFields({
      ...dbObjTypeFields,
      dbObjTypeValue: e,
      screenName: e.text.replace(/\s/g, "").toLowerCase(),
    });
  };

  const { dbObjTypeValue: value } = dbObjTypeFields;
  const treeData = React.useMemo(
    () => {
      return processTreeData(
        dbObjTypeFields.dbObjTypeData,
        {
          expanded,
          value,
          filter,
        },
        fields
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [expanded, dbObjTypeFields, filter]
  );

  const onFilterChange = (event) => setFilter(event.filter);

  const handleDateChange = (e) => {
    setDateFields({
      ...dateFields,
      [e.target.name]: e.target.value,
    });
    setErrorObj({
      ...errorObj,
      [e.target.name]: "",
      commonDateValidate: "",
    });
  };

  const exportFileName = () => {
    let name = camelize(selectedRoleType.toLowerCase());
    let fileName = "";
    fileName = `Export_Login_Log_${name}.xlsx`;
    return fileName;
  };

  const checkSearchButton = () => {
    const isStartDateEmpty = dateFields.start_date === "";
    const isEndDateEmpty = dateFields.end_date === "";
    const isDbTypeValueEmpty = dbObjTypeFields.dbObjTypeValue.text === "";

    let isDisabled =
      dbObjTypeFields.dbTypeListLoading ||
      isStartDateEmpty ||
      isEndDateEmpty ||
      isDbTypeValueEmpty ||
      isDbTypeValueEmpty;

    return isDisabled;
  };

  const { columnReorderData } = useColumnReorder(cookiesData, setColumnsData, "", "procare_system");

  const [roleTypeKeyList, setRoleTypeKeyList] = React.useState([]);

  const handleRoleFieldChange = (value, name) => {
    // if(value.length>1){
    //     value = value.filter(val=> val.id != 0)
    // } else if(value.length == 0){
    //     // value.push(defaultSelectedOption)
    // }
    setRoleAccessDataFields({
      ...roleAccessDataFields,
      valuesData: value,
      [name]: value,
    });
  };

  const getRolesData = () => {
    GETAPI(false, GET_DB_ROLE_TYPE_KEY_LIST, null, generateHeader(), null, dispatch).then((res) => {
      if (res && res.data) {
        if (res.data.out_parameters.out_ret_code === 0) {
          setRoleTypeKeyList(res.data.row_result);
          let formatResponse = formatData(res.data.row_result);
          let data = {
            ...roleAccessDataFields,
            dropdownData: formatResponse,
            // valuesData: [formatResponse[0]],
          };
          setOriginRoleAccessData(data.dropdownData);
          setRoleAccessDataFields(data);
        } else {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
        }
      }
    });
  };
  const formatData = (data) => {
    const convertedData = data.map((item) => ({
      text: item.db_role_type_name,
      key: item.db_role_type_abbr,
      id: item.db_role_type_key,
    }));
    // convertedData.unshift(defaultSelectedOption);
    return convertedData;
  };
  return (
    <>
      <div className="Main">
        <div className="content">
          <div className="content-head">
            <HeaderPage pageProps={pageProps} headerConfig={headerConfig} />
          </div>

          <div className="content-body">
            <div className="dtu-file-container">
              <ul className={"Filter-links auditlogform"}>
                {userRole == "adm1" && (
                  <div className={"k-form-field-wrap-popup valueDropdown width38em"}>
                    <Label>{"Role Type*:"}</Label>
                    <MultiSelectDropdown
                      name={"roleAccess"}
                      module="roleAccess"
                      data={roleAccessDataFields.dropdownData}
                      textField="text"
                      onOpen={(data) => {
                        setRoleAccessDataFields({
                          ...roleAccessDataFields,
                          dropdownData: data,
                        });
                      }}
                      dataItemKey="id"
                      valueData={roleAccessDataFields.valuesData}
                      onChange={(data, name) => {
                        handleRoleFieldChange(data, name);
                      }}
                      filterable={true}
                      onFilterChange={(dataValue) => {
                        setRoleAccessDataFields({
                          ...roleAccessDataFields,
                          dropdownData: dataValue,
                        });
                      }}
                      autoClose={false}
                      autoBind={true}
                      isSelectALl={true}
                      dataList={originRoleAccessData}
                      loading={roleAccessDataFields.dropdownData.length == 0}
                      selectAllId={0}
                    />
                  </div>
                )}

                <div ref={divRef} className={"k-form-field-wrap-popup width20em"}>
                  <Label>{"Login Status*:"}</Label>
                  <CustomDropdown
                    data={login_log_status}
                    textField="text"
                    dataItemKey="id"
                    valueData={login_log_status.find((c) => c.text === loginLogStatusField.loginLogStatusValue.text)}
                    value={loginLogStatusField.loginLogStatusValue}
                    onChange={onChangeLoginLogStatus}
                    onFilterChange={onFilterChange}
                    autoClose={false}
                    autoBind={true}
                    filterable={false}
                    // isSelectALl={true}
                    // dataList={eventTypeList}
                    // loading={eventsTypeFields.isEventTypeDataLoading}
                  />
                  <Error>{errorObj.db_obj_type}</Error>
                </div>

                <div className={"k-form-field-wrap-popup valueDropdown width20em"}>
                  <Label>{"Start Date* : "}</Label>
                  <DatePicker
                    value={dateFields?.start_date}
                    name="start_date"
                    format="yyyy-MM-dd"
                    onChange={(e) => {
                      handleDateChange(e);
                    }}
                    formatPlaceholder={{
                      year: "yyyy",
                      month: "mm",
                      day: "dd",
                    }}
                    placeholder="yyyy-mm-dd"
                    toggleButton={CustomToggleButton}
                  />
                  <Error>{errorObj.start_date}</Error>
                </div>
                <Error>{dbObjTypeFields.startDateError}</Error>
                <div className={"k-form-field-wrap-popup valueDropdown width20em"}>
                  <Label>{"End Date* : "}</Label>
                  <DatePicker
                    toggleButton={CustomToggleButton}
                    value={dateFields?.end_date}
                    name="end_date"
                    format="yyyy-MM-dd"
                    onChange={(e) => {
                      handleDateChange(e);
                    }}
                    formatPlaceholder={{
                      year: "yyyy",
                      month: "mm",
                      day: "dd",
                    }}
                    placeholder="yyyy-mm-dd"
                  />
                  <Error>{errorObj.end_date}</Error>
                  <Error>{errorObj.commonDateValidate}</Error>
                </div>
                <Error>{dateFields.validationError}</Error>

                <Button
                  primary={true}
                  className="searchbtn"
                  // disabled={checkSearchButton()}
                  type={"submit"}
                  onClick={(e) => {
                    onSearchButtonClick();
                  }}
                >
                  <i className="fas fa-search"></i>
                </Button>
              </ul>

              <div className="auditLog-title">
                <h1>{`${toCamelCase(selectedRoleType)}`}</h1>
              </div>

              {isSearchClick ? <LoadingPanel /> : false}
              {/* {loginLogLoadingState ? <LoadingPanel /> : false} */}

              {gridColumns.length > 0 && !isSearchClick && (
                <>
                  <DataTable
                    isAPICalling={isAPICalling}
                    initialLoading={initialLoading}
                    data={data}
                    id={DATA_TABLE_ID}
                    itemChange={itemChange}
                    pageData={pageData}
                    dataCount={dataCount}
                    customColumn={AuditColumn}
                    columns={gridColumns}
                    module={"login-log"}
                    fileName={exportFileName()}
                    defaultPageSize={defaultPageSize}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    handlePageChange={handlePageChange}
                    handleColumnMenu={handleColumnMenu}
                    refreshClick={onRefreshClick}
                    onClearFilter={onClearFilter}
                    noDataFound={noDataFound}
                    isExportDataClick={exportDataClick}
                    setExportData={setExportDataClick}
                    getExportData={getExportData}
                    exportData={exportData}
                    reorderable={true}
                    isDragMode={false}
                    columnReorderData={columnReorderData}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(LoginLogs);
